import styled from 'styled-components';
import colors from 'constants/colors';

export const DefaultIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .icon {
    width: ${(props) => (props.width ? props.width : ' 15px')};
    height: ${(props) => (props.height ? props.height : ' 15px')};
    ${(props) => (props.colorReverse ? 'filter: invert(1);': null)};
  }
`;

export const OverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 300px;
  min-height: 120px;
  padding: 16px;
  border: 1px solid ${({backgroundColor}) => backgroundColor ?backgroundColor:colors.dimGrey};
  background-color: ${colors.black2};

  .item {
    width: 100%;
    border-top: 1px solid ${colors.dimGrey};
    margin: 16px 0 0 0;
  }

  .info {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    width: 100%;
    color: ${colors.white};
    font-size: 10px;
    font-weight: 300; 
    margin: 16px 0 0 0;

    .field-name {
      width: 45%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      column-gap: 5px;
      color: ${colors.silver};
      white-space: nowrap;
      font-size: 14px;
      font-weight: 600;

      svg{
        width: 20px;
        margin-right: 5px;
      }
    }

    .field-value {
      width: 55%;
      text-align: right;
      color: ${colors.white};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      font-weight: 600;
    }

    .highlight {
      color: ${colors.lightGreen};
      font-size: 14px;
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;   
    }
  }

  .buttonContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    margin-top: 16px;
  }
`;


export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: ${(props) => props.backgroundColor};
  width: ${(props) => props.width ? props.width: '100%'};
  height: ${(props) => props.height ? props.height: '100%'};
  line-height: ${(props) => props.height};
  margin: 2px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  touch-action: none;

  .roomContent {
    width: 100%;
    height: 100%;
    ${({ selected }) => (selected? `
      border: 2px solid ${colors.white};
    ` : null)};

    .roomNumber {
      position: absolute;
      top: 4px;
      left: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 14px;
      height: 10px;
      color: ${(props) => (props.colorReverse ? colors.black1: colors.white)};
      font-size: 6px;
      font-weight: 600;
      letter-spacing: 0.5px;
      z-index: 500;
      -webkit-user-select: none; /* Safari */
      -moz-user-select: none;    /* Firefox */
      -ms-user-select: none;     /* IE10+/Edge */
      user-select: none;         /* standard */
    }
  }

  ${({roomNumber, selected, needsFix, backgroundColor, floorBackgroundColor}) => {
    switch (roomNumber) {
      case '802':
      case '905':
      case '1005':
      case '818':
      case '924':
      case '1025':
        return ` 
          ::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            right: -3px;
            bottom: -3px;
            border: 6px solid ${floorBackgroundColor};
            border-top-color: transparent;
            border-left-color: transparent;
          }
        `
      case '825':
      case '932':
      case '1033':
      case '809':
      case '913':
      case '1013':
        return ` 
          ::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            left: -3px;
            bottom: -3px;
            border: 6px solid ${floorBackgroundColor};
            border-top-color: transparent;
            border-right-color: transparent;
          }
        `
      case '823':
      case '930':
      case '1031':
      case '811':
      case '915':
      case '1015':
        return ` 
          ::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            right: -3px;
            top: -3px;
            border: 6px solid ${floorBackgroundColor};
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        `
      case '804':
      case '907':
      case '1007':
      case '816':
      case '922':
      case '1023':
        return ` 
          ::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            left: -3px;
            top: -3px;
            border: 6px solid ${floorBackgroundColor};
            border-bottom-color: transparent;
            border-right-color: transparent;
          }
        `
      case '824':
      case '931':
      case '1032':
        return ` 
          ::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            right: -3px;
            bottom: -3px;
            border: 10px solid ${floorBackgroundColor};
            border-top-color: transparent;
            border-left-color: transparent;
          }
        `
      case '803':
      case '906':
      case '1006':
        return ` 
          ::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            left: -3px;
            bottom: -3px;
            border: 10px solid ${floorBackgroundColor};
            border-top-color: transparent;
            border-right-color: transparent;
          }
        `
      case '817':
      case '923':
      case '1024':
        return ` 
          ::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            right: -3px;
            top: -3px;
            border: 10px solid ${floorBackgroundColor};
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        `
      case '810':
      case '914':
      case '1014':
        return ` 
          ::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            left: -3px;
            top: -3px;
            border: 10px solid ${floorBackgroundColor};
            border-bottom-color: transparent;
            border-right-color: transparent;
          }
        `
      case '821':
      case '928':
        return ` 
          ::before {
            content: '';
            width: 20px;
            height: 12px;
            position: absolute;
            left: -3px;
            bottom: -3px;
            background-color: ${floorBackgroundColor};
          }
        `
      case '813':
      case '918':
        return `
          ::before {
            content: '';
            width: 12px;
            height: 20px;
            position: absolute;
            left: -3px;
            bottom: -3px;
            background-color: ${floorBackgroundColor};
          }
        `
      case '806':
      case '909': 
        return `
          ::before {
            content: '';
            width: 20px;
            height: 12px;
            position: absolute;
            right: -3px;
            bottom: -3px;
            background-color: ${floorBackgroundColor};
          }
        `
      case '830':
        return `
          height: 52px;
          ::before {
            content: '';
            position: absolute;
            right: 0;
            bottom: -20px;
            width: 26px;
            height: 20px;
            background-color: ${backgroundColor};
            border-style: solid;
            border-width: ${selected? '0 2px 2px 2px': '0 0 0 0'};
            border-color: ${colors.white};
          }
          ::after {
            content: '';
            position: absolute;
            right: 2px;
            bottom: -1px;
            width: 22px;
            height: 3px;
            background-color: ${backgroundColor};
          }
        `
      case '838':
        return `
          top: 16px;
          height: 60px;
          ::before {
            content: '';
            position: absolute;
            top: -20px;
            left: 0px;
            width: 22px;
            height: 20px;
            background-color: ${backgroundColor};
            border-style: solid;
            border-width: ${selected? '2px 2px 0 2px': '0 0 0 0'};
            border-color: ${colors.white};
          }
          ::after {
            content: '';
            position: absolute;
            left: 2px;
            top: -0.5px;
            width: 18px;
            height: 3px;
            background-color: ${backgroundColor};
          }
        `
      default:
        return null
    }
  }}; 
`;

export const Border = styled.div`
  position: absolute;
  z-index: 200;

  ${({roomNumber}) => {
    switch (roomNumber) {
      case '802':
      case '905':
      case '1005':
        return `
          height: 6px;
          width: 6px;
          right: 52px;
          top: 39px;
          background: linear-gradient(-45deg, transparent 42%, ${colors.white} 42%, ${colors.white} 58%, transparent 58%);
        `
      case '818': 
      case '924':
      case '1025':
        return `
          height: 6px;
          width: 6px;
          left: 38px;
          bottom: 54px;
          background: linear-gradient(-45deg, transparent 42%, ${colors.white} 42%, ${colors.white} 58%, transparent 58%);
        `
      case '825':
      case '932':
      case '1033':
        return `
          height: 6px;
          width: 6px;
          left: 52px;
          top: 39px;
          background: linear-gradient(45deg, transparent 42%, ${colors.white} 42%, ${colors.white} 58%, transparent 58%);
        `
      case '809': 
      case '913':
      case '1013':
        return `
          height: 6px;
          width: 6px;
          right: 38px;
          bottom: 54px;
          background: linear-gradient(45deg, transparent 42%, ${colors.white} 42%, ${colors.white} 58%, transparent 58%);
        `
      case '823':
      case '930':
      case '1031':
        return `
          height: 6px;
          width: 6px;
          left: 38px;
          top: 54px;
          background: linear-gradient(45deg, transparent 42%, ${colors.white} 42%, ${colors.white} 58%, transparent 58%);
        `
      case '811': 
      case '915':
      case '1015':
        return `
          height: 6px;
          width: 6px;
          right: 52px;
          bottom: 39px;
          background: linear-gradient(45deg, transparent 42%, ${colors.white} 42%, ${colors.white} 58%, transparent 58%);
        `
      case '804':
      case '907':
      case '1007':
        return `
          height: 6px;
          width: 6px;
          right: 38px;
          top: 54px;
          background: linear-gradient(-45deg, transparent 42%, ${colors.white} 42%, ${colors.white} 58%, transparent 58%);
        `
      case '816': 
      case '922':
      case '1023':
        return `
          height: 6px;
          width: 6px;
          left: 52px;
          bottom: 39px;
          background: linear-gradient(-45deg, transparent 42%, ${colors.white} 42%, ${colors.white} 58%, transparent 58%);
        `
      case '824':
      case '931': 
      case '1032': 
        return `
          height: 14px;
          width: 14px;
          left: 34px;
          top: 36px;
          background: linear-gradient(-45deg, transparent 45%, ${colors.white} 45%, ${colors.white} 55%, transparent 55%);
        `
      case '803':
      case '906': 
      case '1006':
        return `
          height: 14px;
          width: 14px;
          right: 34px;
          top: 36px;
          background: linear-gradient(45deg, transparent 45%, ${colors.white} 45%, ${colors.white} 55%, transparent 55%);
        `
      case '817':
      case '923': 
      case '1024':
        return `
          height: 14px;
          width: 14px;
          left: 34px;
          bottom: 36px;
          background: linear-gradient(45deg, transparent 45%, ${colors.white} 45%, ${colors.white} 55%, transparent 55%);
        `
      case '810':
      case '914': 
      case '1014':
        return `
          height: 14px;
          width: 14px;
          right: 34px;
          bottom: 36px;
          background: linear-gradient(-45deg, transparent 45%, ${colors.white} 45%, ${colors.white} 55%, transparent 55%);
        `
      case '821':
      case '928': 
        return `
          height: 10px;
          width: 18px;
          left: 2px;
          bottom: 143px;
          border: solid ${colors.white};
          border-width: 2px 2px 0px 0px;
        `
      case '813':
      case '918': 
        return `
          height: 18px;
          width: 10px;
          left: 150px;
          bottom: 2px;
          border: solid ${colors.white};
          border-width: 2px 2px 0px 0px;
        `
      case '806':
      case '909': 
        return `
          height: 10px;
          width: 18px;
          right: 2px;
          bottom: 143px;
          border: solid ${colors.white};
          border-width: 2px 0px 0px 2px;
        `
      default:
        return null
    }
  }}; 
`;